import '@/plugins/vue-composition-api';
import Vue from 'vue';
import '@/@fake-db/db';
import { i18n } from '@/plugins/i18n';
import '@/styles/styles.scss';
import App from './App.vue';
import './plugins/acl';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import appConfig from './config/app.config';

Vue.config.productionTip = false;
Vue.prototype.$nodeEnv = process.env.NODE_ENV;
Vue.prototype.$isNodeEnvDevelopment = process.env.NODE_ENV === 'development';
Vue.prototype.$nodeOverEnv = process.env.VUE_APP_OVER_ENV;
Vue.prototype.$appConfig = appConfig;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
